import React from 'react'
import './Logo.scss'

function Logo() {
  return (
    <div className="logoContainer">
      <a href="#home">
        <img src='assets/kei-logo-blue.png' />
      </a>
    </div>
  )
}

export default Logo